import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

export type InfoModalType = 'info' | 'warning' | 'error';

export interface InfoModalConfig {
  type: InfoModalType;
  title?: string;
  message: string;
  primaryButton?: {
    text: string;
    action?: () => void;
  };
  secondaryButton?: {
    text: string;
    action?: () => void;
  };
  dismissOnBackdrop?: boolean;
  showCloseButton?: boolean;
}

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class InfoModalComponent {
  @Input() config: InfoModalConfig = {
    type: 'info',
    message: '',
    dismissOnBackdrop: true,
    showCloseButton: true
  };

  @Output() dismissed = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();

  constructor(private modalController: ModalController) {}

  get iconName(): string {
    switch (this.config.type) {
      case 'info':
        return 'information-circle-outline';
      case 'warning':
        return 'warning-outline';
      case 'error':
        return 'alert-circle-outline';
      default:
        return 'information-circle-outline';
    }
  }

  get iconColor(): string {
    switch (this.config.type) {
      case 'info':
        return 'primary';
      case 'warning':
        return 'warning';
      case 'error':
        return 'danger';
      default:
        return 'primary';
    }
  }

  get modalClass(): string {
    return `info-modal info-modal--${this.config.type}`;
  }

  async dismiss() {
    this.dismissed.emit();
    await this.modalController.dismiss();
  }

  async onPrimaryAction() {
    if (this.config.primaryButton?.action) {
      this.config.primaryButton.action();
    }
    this.primaryAction.emit();
    await this.modalController.dismiss('primary');
  }

  async onSecondaryAction() {
    if (this.config.secondaryButton?.action) {
      this.config.secondaryButton.action();
    }
    this.secondaryAction.emit();
    await this.modalController.dismiss('secondary');
  }

  async onBackdropClick() {
    if (this.config.dismissOnBackdrop !== false) {
      await this.dismiss();
    }
  }
}
